export const newLinesToBreaks = (value: string): string => {
    return value ? value.replace(/\n/g, '<br />') : '';
};